// extracted by mini-css-extract-plugin
export default {"card":"salesChart_card__KRqP3"};